import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef(({ className, type, onFocus, ...props }, ref) => {
  // Auto-select content on focus for number inputs so users don't have to manually
  // delete the placeholder "0" before typing a new value.
  const handleFocus = (e) => {
    if (type === 'number') {
      try { e.target.select(); } catch (_) { /* ignore */ }
    }
    if (typeof onFocus === 'function') onFocus(e);
  };
  return (
    <input
      type={type}
      onFocus={handleFocus}
      className={cn(
        "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
